import { useQuery } from '@tanstack/react-query';
import { useSelector } from 'react-redux';
import { fetchLookupOperators } from '@api';
import { getGeneralSlice } from '@store/features';
import { toast } from 'react-toastify';

export const useLookupOperatorsQuery = () => {
  const { segment, operatorType } = useSelector(getGeneralSlice);

  return useQuery({
    queryKey: [
      'lookupOperators',
      {
        segmentTypeId: segment?.id,
        operatorTypeId: operatorType
      }
    ],
    enabled: !!segment,
    placeholderData: [],
    queryFn: ({ queryKey, signal }) => {
      return fetchLookupOperators(queryKey[1], signal)
        .then((response) =>
          response.map(({ operatorId, longName, shortName }) => {
            return {
              operatorLongName: longName,
              operatorShortName: shortName,
              id: operatorId
            };
          })
        )
        .catch((error) => {
          if (error.name !== 'AbortError') {
            toast.error(`Unable to fetch operators`, {
              position: 'top-right'
            });
          }
          return [];
        });
    }
  });
};
